import { Body, Controller, Post, Req } from '@nestjs/common';
import { PlantOperationCapacityService } from './plant-operation-capacity.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { PlantOperationCapacityDto } from './dto/plant-operation-capacity.dto';
import { PlantOperationCapacityRequest } from './dto/plant-operation-capacity.request';
import { ALLPlantOprationCapacityResponse,PlantIdRequest,PlantOperationCapacityResponse } from '@gtpl/shared-models/masters';
import { ApiTags } from '@nestjs/swagger';
import { plantIdRequest } from '../rm-rack-position/dto/plant-request';
@Controller('plant-operation-capacity')
export class PlantOperationCapacityController {
    constructor(
        private  plantOperationCapacityService:  PlantOperationCapacityService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}
      /**
     * creates  a Plant OPeration Capacity
     * @param PlantOperationCapacityDto PlantOperationCapacityDto
     * @returns PlantOperationCapacityResponse
     */
       @Post('/createPlantOperationCapacity')
       async createPlantOperationCapacity(@Body() plantOperationCapacityDto: PlantOperationCapacityDto, @Req() request:Request): Promise<PlantOperationCapacityResponse> {
           try {
               console.log("hiiii")
            return await this.plantOperationCapacityService.createPlantOperationCapacity( plantOperationCapacityDto,false,request);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(PlantOperationCapacityResponse, error);
          }
        }
         /**
     * gets all the Value plant Operation Capacity
     * @returns ALLPlantOprationCapacityResponse which returns all the Value  plant-Operation-Capacity  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */
          @Post('/getAllPlantOperationCapacity')
          async getAllPlantOperationCapacity(@Body() req:PlantIdRequest): Promise<ALLPlantOprationCapacityResponse> {
              try {
                  return await this.plantOperationCapacityService.getAllPlantOperationCapacity(req);
              } catch (error) {
                  return this.applicationExceptionHandler.returnException( ALLPlantOprationCapacityResponse, error);
              }
          }
 /**
     * Activate Or De-Activate Value plantOpertionCapacity
     * @param getSinglePlantOperationCapacity  plantOpertionCapacity
     * @returns Value PlantOperationCapacity
     */
  @Post('/activateOrDeactivatePlantOperationCapacity')
  async activateOrDeactivatePlantOperationCapacity(@Body() plantOperationCapacityReq:PlantOperationCapacityRequest): Promise<PlantOperationCapacityResponse> {
      try {console.log(plantOperationCapacityReq,'-----------')
      
          return await this.plantOperationCapacityService.activateOrDeactivatePlantOperationCapacity(plantOperationCapacityReq);
          
      } catch (err) {
          return this.applicationExceptionHandler.returnException(PlantOperationCapacityResponse, err);
          
      } 
  }  
   /**
     *  updates a  value plant operation capacity
     * @param PlantOperationCapacityDto  Plant Operation Capacity DTO
     * @returns PlantOperationCapacityResponse
     */
    @Post('/updatePlantOperationCapacity')
    async updatePlantOperationCapacity(@Body() plantOperationCapacityDto:PlantOperationCapacityDto, @Req() request:Request): Promise<PlantOperationCapacityResponse> {
        try {
         return await this.plantOperationCapacityService.createPlantOperationCapacity(plantOperationCapacityDto,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(PlantOperationCapacityResponse, error);
       }
     }
}
